import {fun_Download, fun_PostAction} from "@/api/index";
import {fun_DownloadFile} from "@/utils/validate";
import { Loading } from "element-ui";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 全局加载
      fullLoading: null,
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [
        {
          name: "台帐导出",
          type: "success",
        },
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        tenderPrjName: null, // 项目名称
        investProjectCode: null, // 投资项目统一代码
        regulators: null, // 招投标监管部门
        areaCode: null, // 行政区划
        tenderClassNum: null, // 招标类别
        projectStateFlag: null, // 项目状态标志
        startTime: null, // 开始时间
        endTime: null, // 截止时间
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "tenderPrjName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "投资项目统一代码：",
          value: "investProjectCode",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "select",
          label: "项目状态：",
          value: "projectStateFlag",
          placeholder: "请输入",
          optionData: [
            { name: "已完成项目", value: "0" },
            { name: "未完成项目", value: "1" },
          ],
        },
        {
          type: "select",
          label: "招标类别：",
          value: "tenderClassNum",
          placeholder: "请选择",
          disabled: false,
          queryParams: {
            url: "/dataDictionaryEntries/DictionaryCombobox",
            zdid: "201510200918460003"
          }
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请选择",
          disabled: false,
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
        {
          type: "select",
          label: "行政区划：",
          value: "areaCode",
          placeholder: "请选择",
          disabled: false,
          queryParams: {
            url: "/dataDictionaryEntries/BasicDataCombobox",
            zdid: "202109241434440618"
          }
        },
        {
          type: "date",
          label: "开始日期：",
          dateType: "date",
          value: "startTime",
          placeholder: "请输入",
          valueFormat: "yyyy-MM-dd",
        },
        {
          type: "date",
          label: "结束日期：",
          dateType: "date",
          value: "endTime",
          placeholder: "请输入",
          valueFormat: "yyyy-MM-dd",
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "tenderPrjName",
          minWidth: "300",
          fixed: true,
        },
        {
          label: "标段号",
          prop: "section",
          minWidth: "80",
          fixed: true,
        },
        {
          label: "招标方式",
          prop: "tenderTypeNumName",
          minWidth: "100",
        },
        {
          label: "招标类别",
          prop: "tenderClassName",
          minWidth: "150",
        },
        {
          label: "招标组织形式",
          prop: "tenderMethod",
          minWidth: "120",
        },
        {
          label: "资格审查方式",
          prop: "prequalificationTypeName",
          minWidth: "120",
        },
        {
          label: "投资项目统一代码",
          prop: "investProjectCode",
          minWidth: "230",
        },
        {
          label: "公告开始时间",
          prop: "noticeStartDate",
          minWidth: "200",
        },
        {
          label: "中标金额（万元）",
          prop: "winningPrice",
          minWidth: "150",
        },
        {
          label: "行政区划",
          prop: "areaCodeName",
          minWidth: "150",
        },
        {
          label: "行政监督部门",
          prop: "regulatorsName",
          minWidth: "300",
        },
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [], // 勾选数组
      // 温馨提示
      tipList: [],
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
    // 查询一览数据
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/tenderProjectDataStatistics/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      this.form[i] = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      // 全局加载
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)"
      });
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author shuhua
     */
    fun_Click(e) {
      switch (e) {
        case "台帐导出":
          this.fun_ImportExcel();
          break;
        default:
          "";
      }
    },
    /**
     * 台帐导出的方法
     * @author shuhua
     */
    fun_ImportExcel() {
      // 全局加载
      this.fun_Loading();
      try {
        // 请求，获取结果集
        fun_Download("/tenderProjectDataStatistics/export", {
          ...this.form,
        }).then(res => {
          // 关闭加载
          this.fullLoading.close();
          // 获取到Content-Disposition;filename
          let fileNames = res.headers["content-disposition"];
          if (fileNames) {
            let regFileNames = fileNames.match(/=(.*)$/)[1];
            // 调用下载文件公共方法
            fun_DownloadFile(res, decodeURIComponent(regFileNames));
            // 关闭加载
            this.loading = false;
          } else {
            // 关闭加载
            this.loading = false;
            // 提示请求失败消息
            this.$message.error("文件不存在！");
          }
        });
      } catch {
      }
    },
  }
};
